import React, { useEffect, useState } from 'react';
import { Modal, Table, Spin, Space, Button } from 'antd';
import { ZoomInOutlined, FileSearchOutlined } from '@ant-design/icons';
import moment from 'moment-jalaali';
import strings from '../../utils/strings';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { useReportsStore } from '../../store/slices/createReportsSlice';
import InsuranceDetails from '../shared/insuranceDetails/InsuranceDetails';
import EndorsementInfo from '../issue-endorsement-report/EndorsementInfo';

export default function UserEndorsementReport({ userId, isTab }) {
    const general = useGeneralStore();
    const reports = useReportsStore();
    const visible = general.view.userEndorsementReportModal;
    const { loading, data } = reports.userEndorsementReport;
    const [requestId, setRequestId] = useState();
    const [endorsementId, setEndorsementId] = useState();

    useEffect(() => {
        if (visible && !isTab && userId) {
            reports.getUserEndorsementReport(userId);
        }
    }, [visible, isTab, userId]);

    const columns = [
        {
            title: "جزئیات الحاقیه",
            dataIndex: "endorsementDetails",
            key: "endorsementDetails",
            width: 100,
            render: (_, record) => (
                <Button type='link' onClick={() => {
                    reports.getEndorsementDetailsInfo(record.EndorsementId);
                    setEndorsementId(record.EndorsementId);
                    general.ToggleEndorsementDetailsModal();
                }}><FileSearchOutlined /></Button>
            )
        },
        {
            title: "کد درخواست",
            dataIndex: "InsuranceRequestId",
            key: "InsuranceRequestId",
            width: 120,
            render: (text, record) => (
                <Space size="middle">
                    <span>{text || "-"}</span>
                    <Button type='link' onClick={() => {
                        reports.getInsuranceDetailsInfo(record.InsuranceRequestId);
                        setRequestId(record.InsuranceRequestId);
                        general.ToggleInsuranceDetailsModal();
                    }}><ZoomInOutlined /></Button>
                </Space>
            )
        },
        {
            title: "کد رهگیری",
            dataIndex: "TrackingCode",
            key: "TrackingCode",
            width: 120,
        },
        {
            title: "نام درخواست کننده",
            dataIndex: "ApplicantFullName",
            key: "ApplicantFullName",
            width: 150,
        },
        {
            title: "نام بیمه گزار",
            dataIndex: "PolicyOwnerFullName",
            key: "PolicyOwnerFullName",
            width: 150,
        },
        {
            title: "ذی‌نفع دوم",
            dataIndex: "OwnerUserFullName",
            key: "OwnerUserFullName",
            width: 150,
            render: (data) => data ? data : "-",
        },
        {
            title: "نوع الحاقیه",
            dataIndex: "TypeTitle",
            key: "TypeTitle",
            width: 150,
        },
        {
            title: "وضعیت",
            dataIndex: "StatusTitle",
            key: "StatusTitle",
            width: 120,
        },
        {
            title: "شرکت بیمه",
            dataIndex: "CompanyName",
            key: "CompanyName",
            width: 150,
        },
        {
            title: "رشته بیمه",
            dataIndex: "BranchTitle",
            key: "BranchTitle",
            width: 150,
        },
        {
            title: "تاریخ ایجاد",
            dataIndex: "IssueDate",
            key: "IssueDate",
            width: 150,
            render: (data) =>
                data && strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm ")),
        },
        {
            title: "مبلغ (ریال)",
            dataIndex: "Amount",
            key: "Amount",
            width: 120,
            render: (data) => data != null ? strings.getFarsiNum(Number(data).toLocaleString()) : "-",
        },
    ];

    const content = (
        <Spin spinning={loading}>
            <Table
                bordered
                columns={columns}
                dataSource={data?.Items ? data.Items : (Array.isArray(data) ? data : [])}
                rowKey="Id"
                scroll={{ x: 1500 }}
                pagination={{ pageSize: 10 }}
                locale={{ emptyText: "داده‌ای یافت نشد" }}
            />
            <InsuranceDetails requestId={requestId} />
            <EndorsementInfo endorsementId={endorsementId} />
        </Spin>
    );

    if (isTab) {
        return content;
    }

    return (
        <Modal
            title="گزارش الحاقیه‌های کاربر"
            open={visible}
            onCancel={() => general.ToggleUserEndorsementReportModal()}
            footer={null}
            width={1000}
            destroyOnClose
        >
            {content}
        </Modal>
    );
}
